<wk-icon-filled-close-sprite-pds3 />
<wk-icon-pencil-sprite-pds3 />
<wk-icon-trash-sprite-pds3 />
<wk-icon-save-sprite-pds3 />
@if (filtersService?.activeFilters?.size > 0 && !isFavoriteFilterEditMode) {
    <button-field-pds3 type="text" flowClass="custom-wk-clear-button">
        <button type="button" class="navbar_clearFilters" (click)="clearAllFilters()">
            <icon-pds3 name="wk-icon-filled-close"></icon-pds3>
            <span>{{ "FiltersSidebar.Labels.ClearAllFilters" | translate }}</span>
        </button>
    </button-field-pds3>
}
<wk-search />
<button
    kendoButton
    (click)="open()"
    [class.wk-fm__funnel--filled]="filtersService?.activeFilters?.size > 0"
    class="wk-fm__navbar-filter wk-fm__funnel"
></button>
<side-modal-pds3 cg3-theme="PDS-v3" (userRequest)="close($event)" [isOpen]="this.isOpen">
    <vertical-layout-pds3 flowClass="vertical-layout">
        <vertical-layout-header-pds3>
            <h5 class="wk-fm__sidebar-filter-header">
                <span class="wk-fm__sidebar-filter-title"> {{ "FiltersSidebar.Title" | translate }}</span>
                <div (click)="open()" flow-id="close-button" class="wk-fm__sidebar-filter-header close-button">
                    <icon-pds3 name="wk-icon-close"> </icon-pds3>
                </div>
            </h5>
        </vertical-layout-header-pds3>
        <vertical-layout-content-pds3 flowClass="vertical-layout-content">
            <accordion-pds3>
                <accordion-item-pds3
                    [isOpen]="accordionStates['Accordion_Filters_Favorites']"
                    (userRequest)="onAccordionOpen($event, 'Accordion_Filters_Favorites')"
                >
                    <accordion-item-header-pds3 *accordionItemHeading2Pds3>
                        {{ "FiltersSidebar.Labels.MyFilters" | translate }}
                    </accordion-item-header-pds3>
                    <div class="favorites-filters-suggestions" *accordionItemBodyPds3>
                        @for (model of favoritesFilters; let idx = $index; track $index) {
                            <pill-suggestion-field-pds3 size="small" [isSelected]="model?.active">
                                <button type="button" (click)="toggleFavorite(model)" [attr.aria-selected]="model?.active">
                                    {{ model.id === "assigned-to-me" ? ("FiltersSidebar.Labels.AssignedToMe" | translate) : model.name }}
                                </button>
                            </pill-suggestion-field-pds3>
                        }
                    </div>
                </accordion-item-pds3>

                <accordion-item-pds3
                    [isOpen]="accordionStates['Accordion_Filters_Active']"
                    (userRequest)="onAccordionOpen($event, 'Accordion_Filters_Active')"
                >
                    <accordion-item-header-pds3 *accordionItemHeading2Pds3>{{
                        "FiltersSidebar.Labels.ActiveFilters" | translate
                    }}</accordion-item-header-pds3>
                    <div *accordionItemBodyPds3>
                        @if (filtersService?.activeFilters?.size > 0 && !isFavoriteFilterEditMode) {
                            <button-field-pds3 type="text" flowClass="custom-wk-clear-button">
                                <button type="button" class="navbar_clearFilters wk-fm__navbar-filter-btn--padding" (click)="clearAllFilters()">
                                    <icon-pds3 name="wk-icon-filled-close"></icon-pds3>
                                    <span>{{ "FiltersSidebar.Labels.ClearAllFilters" | translate }}</span>
                                </button>
                            </button-field-pds3>
                        }

                        @if (this.filtersService?.activeFilters?.size === 0) {
                            <label class="wk-fm__navbar-filter-no-active-filters">{{ "FiltersSidebar.Labels.NoActiveFilters" | translate }}</label>
                        }

                        <div [attr.class]="'pill-story7'">
                            <div [attr.class]="'pill-group-container'">
                                <pill-group-pds3
                                    cg3-theme="PDS-v3"
                                    (visiblePillsChange)="onVisiblePillsChange($event)"
                                    groupId="pill-group-active-filters"
                                    [srLabelledBy]="headingId"
                                    [initLinesCount]="linesCount"
                                    [isExpanded]="isExpanded"
                                >
                                    <sr-only-pds3 flowClass="pill-group-heading-sr" *headingPds3>
                                        <h3 [attr.id]="headingId" flow-id="pill-group-heading">Active filters</h3>
                                    </sr-only-pds3>
                                    <!-- Alerts Pills -->

                                    @if (alertsFilterModel?.selection?.length) {
                                        @for (sel of alertsFilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(alertsFilterModel, sel, onAlertsChanged)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3> {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close"> </icon-pds3>
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Categories Pills -->
                                    @if (categoriesFilterModel?.selection?.length) {
                                        @for (sel of categoriesFilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(categoriesFilterModel, sel, onCategoriesChanged)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3> {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close"> </icon-pds3>
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Tags Pills -->
                                    @if (tagsFilterModel?.selection?.length) {
                                        @for (sel of tagsFilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(tagsFilterModel, sel, onTagsChanged)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3> {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close"> </icon-pds3>
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Delivery Methods Pills -->
                                    @if (deliveryMethodsFilterModel?.selection?.length) {
                                        @for (sel of deliveryMethodsFilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button
                                                    (click)="onPillClose(deliveryMethodsFilterModel, sel, onDeliveryMethodsChanged)"
                                                    type="button"
                                                >
                                                    <sr-only-pds3>Remove</sr-only-pds3> {{ deliveryMethodsFilterModel?.label | wkTranslate }} -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close"> </icon-pds3>
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Group 1 Pills -->
                                    @if (group1FilterModel?.selection?.length) {
                                        @for (sel of group1FilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(group1FilterModel, sel, onGroup1Changed)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3> {{ group1FilterModel?.label | wkTranslate }} -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close"> </icon-pds3>
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Group 2 Pills -->
                                    @if (group2FilterModel?.selection?.length) {
                                        @for (sel of group2FilterModel.selection; let idx = $index; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(group2FilterModel, sel, onGroup2Changed)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3> {{ group2FilterModel?.label | wkTranslate }} -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close"> </icon-pds3>
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <!-- Group Name Pill -->
                                    @if (groupnameFilterModel?.text) {
                                        <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                            <button (click)="groupnameFilterModel.text = ''; onGroupnameChanged('')" type="button">
                                                <sr-only-pds3>Remove</sr-only-pds3> {{ groupnameFilterModel.text }}
                                                <icon-pds3 name="wk-icon-filled-close"> </icon-pds3>
                                            </button>
                                        </pill-dismissible-field-pds3>
                                    }

                                    <!-- Deadline Pills -->
                                    @if (deadlineApril30thModel?.selected) {
                                        <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                            <button (click)="deadlineApril30thModel.selected = false; onDeadlineChanged()" type="button">
                                                <sr-only-pds3>Remove</sr-only-pds3> {{ deadlineApril30thModel.label | wkTranslate }}
                                                <icon-pds3 name="wk-icon-filled-close"> </icon-pds3>
                                            </button>
                                        </pill-dismissible-field-pds3>
                                    }
                                    @if (deadlineJune15thModel?.selected) {
                                        <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                            <button (click)="deadlineJune15thModel.selected = false; onDeadlineChanged()" type="button">
                                                <sr-only-pds3>Remove</sr-only-pds3> {{ deadlineJune15thModel.label | wkTranslate }}
                                                <icon-pds3 name="wk-icon-filled-close"> </icon-pds3>
                                            </button>
                                        </pill-dismissible-field-pds3>
                                    }

                                    <!-- Assignees Pills -->
                                    @for (model of this.assigneesFilterGeneratorService.models(); track model.id) {
                                        @for (sel of model.selection; track $index) {
                                            <pill-dismissible-field-pds3 *pillItemPds3 size="small">
                                                <button (click)="onPillClose(model, sel, onAssigneeChanged)" type="button">
                                                    <sr-only-pds3>Remove</sr-only-pds3> {{ model.label | wkTranslate }} -
                                                    {{ sel.text | wkTranslate }}
                                                    <icon-pds3 name="wk-icon-filled-close" />
                                                </button>
                                            </pill-dismissible-field-pds3>
                                        }
                                    }

                                    <pill-suggestion-field-pds3 *pillMoreButtonPds3 size="small">
                                        @if (morePillsCount > 0) {
                                            <button
                                                (click)="onExpandButtonToggle()"
                                                type="button"
                                                flow-id="pill-group-more-button"
                                                aria-controls="pill-group-active-filters"
                                                [attr.aria-expanded]="this.isExpanded"
                                            >
                                                @if (isExpanded) {
                                                    {{ "FiltersSidebar.Actions.ShowLess" | translate }}
                                                }
                                                @if (!isExpanded) {
                                                    {{ "+" + morePillsCount + " " + ("FiltersSidebar.Actions.ShowMore" | translate) }}
                                                }
                                            </button>
                                        }
                                    </pill-suggestion-field-pds3>
                                </pill-group-pds3>
                            </div>
                        </div>
                        <div cg3-theme="PDS-v3" id="saved-filters" class="wk-fm__saved-filters">
                            @if (currentFavoriteFilter?.id !== "assigned-to-me" && isFavoriteFilterEditMode) {
                                <button-field-pds3 type="text" size="small">
                                    <button type="button" (click)="enableFavoriteFilterEditMode(false)" class="wk-fm__save-filter-btn--color">
                                        <icon-pds3 name="wk-icon-close"></icon-pds3>
                                        <span>{{ "Actions.Cancel" | translate }}</span>
                                    </button>
                                </button-field-pds3>
                            }
                            @if (
                                currentFavoriteFilter?.id !== "assigned-to-me" &&
                                favoritesFilters.length > 1 &&
                                currentFavoriteFilter.id.length > 0 &&
                                !isFavoriteFilterEditMode
                            ) {
                                <button-field-pds3 type="text" size="small" flowClass="custom-wk-delete-button" color="danger">
                                    <button type="button" (click)="openModal('delete')">
                                        <icon-pds3 name="wk-icon-trash"></icon-pds3>
                                        <span>{{ "Actions.Delete" | translate }}</span>
                                    </button>
                                </button-field-pds3>
                            }
                            @if (currentFavoriteFilter?.id !== "assigned-to-me" && currentFavoriteFilter.id.length > 0 && !isFavoriteFilterEditMode) {
                                <button-field-pds3 type="text" size="small">
                                    <button type="button" class="wk-fm__save-filter-btn--border" (click)="enableFavoriteFilterEditMode(true)">
                                        <icon-pds3 name="wk-icon-pencil"></icon-pds3>
                                        <span>{{ "Actions.Edit" | translate }}</span>
                                    </button>
                                </button-field-pds3>
                            }
                            @if (currentFavoriteFilter?.id !== "assigned-to-me" && isFavoriteFilterEditMode) {
                                <button-field-pds3 type="text" size="small">
                                    <button type="button" flow-id="text-button" (click)="openModal('rename')">
                                        <icon-pds3 name="wk-icon-pencil"></icon-pds3>
                                        <span>{{ "Actions.Rename" | translate }}</span>
                                    </button>
                                </button-field-pds3>
                            }

                            @if (
                                (!currentFavoriteFilter.id &&
                                    currentFavoriteFilter?.id !== "assigned-to-me" &&
                                    filtersService?.activeFilters?.size > 0) ||
                                (currentFavoriteFilter?.id !== "assigned-to-me" && isFavoriteFilterEditMode)
                            ) {
                                <button-field-pds3 type="text" size="small">
                                    <button
                                        type="button"
                                        class="wk-fm__save-filter-btn--border"
                                        (click)="
                                            modalActionType = 'save';
                                            currentFavoriteFilter.id.length > 0 ? saveFavoritesFilter(currentFavoriteFilter.name) : openModal('save')
                                        "
                                    >
                                        <icon-pds3 name="wk-icon-save"></icon-pds3>
                                        <span>{{ "Actions.Save" | translate }}</span>
                                    </button>
                                </button-field-pds3>
                            }
                        </div>
                    </div>
                </accordion-item-pds3>
                <accordion-item-pds3
                    [isOpen]="accordionStates['Accordion_Filters_General']"
                    (userRequest)="onAccordionOpen($event, 'Accordion_Filters_General')"
                >
                    <accordion-item-header-pds3 *accordionItemHeading2Pds3>{{
                        "FiltersSidebar.Labels.General" | translate
                    }}</accordion-item-header-pds3>
                    <div *accordionItemBodyPds3>
                        @if (alertsFilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ alertsFilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="alerts"
                                [data]="alertsFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="alertsFilterModel.selection"
                                (ngModelChange)="onAlertsChanged($event, true)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                            >
                            </kendo-multiselect-wrapper>
                        }
                        @if (categoriesFilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ categoriesFilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="categories"
                                [data]="categoriesFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="categoriesFilterModel.selection"
                                (ngModelChange)="onCategoriesChanged($event)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                            >
                            </kendo-multiselect-wrapper>
                        }
                        @if (tagsFilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ tagsFilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="tags"
                                [data]="tagsFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="tagsFilterModel.selection"
                                (ngModelChange)="onTagsChanged($event)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                            >
                            </kendo-multiselect-wrapper>
                        }
                        @if (groupnameFilterModel && !isiFirmTaxDashboard) {
                            <text-field-pds3
                                size="medium"
                                [label]="groupnameFilterModel.label | translate"
                                labelFor="groupName"
                                class="group-name-text-field"
                            >
                                <input
                                    type="text"
                                    id="groupName"
                                    [(ngModel)]="groupnameFilterModel.text"
                                    (ngModelChange)="onGroupnameChanged($event)"
                                />
                            </text-field-pds3>
                        }
                        @if (group1FilterModel && isGroup1Enabled) {
                            <label class="wk-fm__sidebar-filter-label">{{ group1FilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="group1"
                                [data]="group1FilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="group1FilterModel.selection"
                                (ngModelChange)="onGroup1Changed($event)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                            >
                            </kendo-multiselect-wrapper>
                        }
                        @if (group2FilterModel && isGroup2Enabled) {
                            <label class="wk-fm__sidebar-filter-label">{{ group2FilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="group2"
                                [data]="group2FilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="group2FilterModel.selection"
                                (ngModelChange)="onGroup2Changed($event)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                            >
                            </kendo-multiselect-wrapper>
                        }
                        @if (deliveryMethodsFilterModel) {
                            <label class="wk-fm__sidebar-filter-label">{{ deliveryMethodsFilterModel.label | wkTranslate }}</label>
                            <kendo-multiselect-wrapper
                                name="deliveryMethods"
                                [data]="deliveryMethodsFilterModel.applicableOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [(ngModel)]="deliveryMethodsFilterModel.selection"
                                (ngModelChange)="onDeliveryMethodsChanged($event)"
                                placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                            >
                            </kendo-multiselect-wrapper>
                        }

                        <label class="wk-fm__sidebar-filter-label">{{ "FiltersSidebar.Labels.Deadline" | translate }}</label>

                        <check-mark-group-pds3>
                            @if (deadlineApril30thModel) {
                                <checkbox-field-pds3
                                    labelFor="deadlineApril30th"
                                    size="extra-small"
                                    [label]="deadlineApril30thModel.label | wkTranslate"
                                    *inputPds3
                                >
                                    <input
                                        (change)="onDeadlineChanged()"
                                        id="deadlineApril30th"
                                        type="checkbox"
                                        [(ngModel)]="deadlineApril30thModel.selected"
                                    />
                                </checkbox-field-pds3>
                            }
                            @if (deadlineJune15thModel) {
                                <checkbox-field-pds3
                                    labelFor="deadlineJune15th"
                                    size="extra-small"
                                    [label]="deadlineJune15thModel.label | wkTranslate"
                                    *inputPds3
                                >
                                    <input
                                        (change)="onDeadlineChanged()"
                                        id="deadlineJune15th"
                                        type="checkbox"
                                        [(ngModel)]="deadlineJune15thModel.selected"
                                    />
                                </checkbox-field-pds3>
                            }
                        </check-mark-group-pds3>
                    </div>
                </accordion-item-pds3>
                <accordion-item-pds3
                    [isOpen]="accordionStates['Accordion_Filters_Assignees']"
                    (userRequest)="onAccordionOpen($event, 'Accordion_Filters_Assignees')"
                >
                    <accordion-item-header-pds3 *accordionItemHeading2Pds3>{{
                        "FiltersSidebar.Labels.Assignees" | translate
                    }}</accordion-item-header-pds3>
                    <div *accordionItemBodyPds3>
                        @if (this.assigneesFilterGeneratorService.models().length) {
                            @for (model of this.assigneesFilterGeneratorService.models(); track model.id) {
                                <label class="wk-fm__sidebar-filter-label">{{ model.label | wkTranslate }}</label>
                                <kendo-multiselect-wrapper
                                    name="assignees_{{ $index }}"
                                    [data]="model.applicableOptions"
                                    textField="text"
                                    valueField="value"
                                    [(ngModel)]="model.selection"
                                    (ngModelChange)="onAssigneeChanged(model)"
                                    [valuePrimitive]="false"
                                    placeholder="{{ 'FiltersSidebar.Options.MultiSelect.Select' | translate }}"
                                    noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                    clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                                    [virtual]="true"
                                >
                                </kendo-multiselect-wrapper>
                                @if ($index === 0) {
                                    <h6 class="wk-fm__sidebar-filter-search-by-roles">{{ "FiltersSidebar.Labels.SearchByRoles" | wkTranslate }}</h6>
                                }
                            }

                            <check-mark-group-pds3>
                                @if (cardsReadyToBeWorkedOnModel && isCardsReadyToWorkedOn) {
                                    <checkbox-field-pds3
                                        labelFor="cardsReady"
                                        size="extra-small"
                                        [flowClass]="
                                            isCardsReadyToWorkedOnDisabled ? 'cardsReadyCheckbox cardsReadyCheckbox-disabled' : 'cardsReadyCheckbox'
                                        "
                                        [label]="cardsReadyToBeWorkedOnModel.label | wkTranslate"
                                        *inputPds3
                                    >
                                        <input
                                            (change)="onReadyToBeWorkedOnChanged()"
                                            id="cardsReady"
                                            type="checkbox"
                                            [(ngModel)]="cardsReadyToBeWorkedOnModel.selected"
                                            [disabled]="isCardsReadyToWorkedOnDisabled"
                                        />
                                    </checkbox-field-pds3>
                                }
                            </check-mark-group-pds3>

                            @if (cardsReadyToBeWorkedOnModel && isCardsReadyToWorkedOn && isCardsReadyToWorkedOnDisabled) {
                                <tooltip-pds3
                                    mode="description"
                                    targetSelector=".cardsReadyCheckbox input"
                                    elementId="tooltipCardsReady"
                                    class="tooltip-cards-ready"
                                >
                                    <span> {{ "FiltersSidebar.Labels.MultiRolesTitle" | wkTranslate }}</span>
                                </tooltip-pds3>
                            }
                        }
                    </div>
                </accordion-item-pds3>
            </accordion-pds3>
        </vertical-layout-content-pds3>
    </vertical-layout-pds3>
</side-modal-pds3>

<!-- dialogue modals -->
<ng-template #saveFilterDialogue>
    <div class="modal-header info">
        <h3 class="modal-title pull-left">
            {{
                modalActionType === "rename"
                    ? ("FiltersSidebar.Events.RenameFilterTitle" | wkTranslate)
                    : ("FiltersSidebar.Events.SaveFilterTitle" | wkTranslate)
            }}
        </h3>

        <icon-pds3 name="wk-icon-filled-close" (click)="bsModalRef.hide()" flowClass="custom-close-icon"></icon-pds3>
    </div>
    <div cg3-theme="PDS-v3" class="wk-modal-body">
        <form>
            <div class="form-group">
                <div class="wk-modal-input-container">
                    <label class="wk-modal-input-container--label">{{ "General.Name" | translate }}</label>
                    <text-field-pds3 flowClass="custom-text-field">
                        <input
                            type="text"
                            id="filterNameInput"
                            name="name"
                            required
                            [(ngModel)]="currentFavoriteFilter.name"
                            maxlength="50"
                            autocomplete="off"
                            #filterNameInput
                        />
                    </text-field-pds3>
                </div>
            </div>
            <div class="wk-modal-button-div">
                <button-field-pds3 type="primary" size="large" flowClass="custom-button primary">
                    <button
                        type="button"
                        [attr.aria-disabled]="currentFavoriteFilter.name.trim().length === 0"
                        [disabled]="currentFavoriteFilter.name.trim().length === 0"
                        (click)="saveFavoritesFilter(currentFavoriteFilter.name)"
                    >
                        {{ "Settings.Save" | translate }}
                    </button>
                </button-field-pds3>
                <button-field-pds3 type="secondary" size="large" flowClass="custom-button secondary">
                    <button type="button" flow-id="secondary-button" (click)="bsModalRef.hide()">{{ "Settings.btnCancel" | translate }}</button>
                </button-field-pds3>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #deleteFilterDialogue>
    <div class="modal-header danger">
        <h3 class="modal-title pull-left">{{ "FiltersSidebar.Events.DeleteFilterTitle" | wkTranslate }}</h3>

        <icon-pds3 name="wk-icon-filled-close" (click)="bsModalRef.hide()" flowClass="custom-close-icon"></icon-pds3>
    </div>
    <div class="wk-modal-body delete-dialog">
        <div>
            <div class="wk-modal-body delete-dialog-content">{{ "FiltersSidebar.Events.DeleteConfirmationMessage" | wkTranslate }}</div>
            <ul>
                <li>
                    {{ currentFavoriteFilter?.name }}
                </li>
            </ul>
        </div>

        <div cg3-theme="PDS-v3" class="wk-modal-button-div">
            <button-field-pds3 type="primary" size="large" flowClass="custom-button danger">
                <button type="button" (click)="deleteFavoriteFilter(currentFavoriteFilter?.id)">{{ "General.Delete" | wkTranslate }}</button>
            </button-field-pds3>
            <button-field-pds3 type="secondary" size="large" flowClass="custom-button secondary">
                <button type="button" flow-id="secondary-button" (click)="bsModalRef.hide()">{{ "Settings.btnCancel" | translate }}</button>
            </button-field-pds3>
        </div>
    </div>
</ng-template>
